module.exports = __webpack_public_path__ + "static/img/company_stats.01bc1399.png";